import * as React from 'react';
import FilterChips from '../../grid-filters/FilterChips';
import { GRID_COLUMNS } from '../config/columns';
import { filterOptionLabel } from '../utils/calculation.utils';
import { ColumnFilter, ColumnKey, FiltersState } from '../types/alternative-calculation.types';
import { useTranslate } from '../../../hooks/useTranslate';

export interface AlternativeCalculationChipsProps {
  filters: FiltersState;
  onRemove: (key: ColumnKey) => void;
  onClearAll: () => void;
}

const AlternativeCalculationChips: React.FC<AlternativeCalculationChipsProps> = ({
  filters,
  onRemove,
  onClearAll
}) => {
  const t = useTranslate();
  const columnLabel = (key: ColumnKey): string => {
    const col = GRID_COLUMNS.find((x) => x.key === key);
    return col ? t(col.translationKey, col.label) : key;
  };

  return (
    <FilterChips
      filters={filters}
      columnLabel={columnLabel}
      filterLabel={(key: ColumnKey, filter: ColumnFilter | null) => filterOptionLabel(key, filter)}
      clearAllLabel={t('ALT_CALC_CLEAR_FILTERS', 'Șterge filtrele')}
      onRemove={onRemove}
      onClearAll={onClearAll}
    />
  );
};

export default AlternativeCalculationChips;
